/* eslint-disable no-console */

const isProduction = process.env.NODE_ENV === 'production'

function write(method, context, payload) {
  if (isProduction || typeof console === 'undefined') return

  const args = context ? [context] : []
  if (payload !== undefined) args.push(payload)

  console[method](...args)
}

export function logError(context, error) {
  write('error', context, error)
}

export function logDebug(context, payload) {
  write('log', context, payload)
}
